import { COUNTRY } from '@makro-shopping/product-card';

export function getCurrencyByCountry(country: COUNTRY): string {
  switch (country) {
    case COUNTRY.CAMBODIA:
      return 'USD';
    case COUNTRY.MYANMAR:
      return 'MMK';
    case COUNTRY.THAILAND:
    default:
      return 'THB';
  }
}
